import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography
} from '@mui/material';

import LoadingButton from '../../../components/buttons/Button';

import {
  CreateDemoDomainWT,
  UpdateDemoDomainWT
} from '../../../redux/actions/watchTower/certifyDemoDomainActions';

import global from "../../../global.scss";

const Data = {
  Domain: "",
  Status: "ALLOWED",
  Note: "",
};

const DemoCertifyDomainsModal = ({
  open,
  setOpen,
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(1);

  const handleClose = () => {
    setOpen(false);
    setFormData(Data);
    setMode(1);
  }

  useEffect(() => {
    try {
      if (open) {
        if (update.defaultMode === 1) {
          // mode = 1 - create domain
          setMode(1);
          setFormData(Data);
        } else if (update.defaultMode === 2) {
          // mode = 2 - edit domain
          setMode(2);
          setFormData({
            Domain: update.domain || "",
            Status: update.status || "ALLOWED",
            Note: update.note || "",
          });
        } else {
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    const obj = {
      domain: formData.Domain || "",
      status: formData.Status || "ALLOWED",
      note: formData.Note || "",
    };

    if (mode === 1) {
      dispatch(CreateDemoDomainWT(obj, setLoading)).then(() => {
        handleGet().then(() => {
          handleClose();
        });
      });
    } else if (mode === 2) {
      dispatch(UpdateDemoDomainWT(update.id, obj, setLoading)).then(() => {
        handleGet().then(() => {
          handleClose();
        });
      });
    } else {
      toast.error("Invalid modal");
      handleClose();
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow"
        width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"}
            sx={{ padding: "15px" }}>
            <Typography variant='h6' sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>

            <Box mb={"15px"}>
              <TextField
                label="Domain or email"
                fullWidth
                name="Domain"
                placeholder="gov  ·  agency.gov  ·  jane@agency.gov"
                value={formData.Domain}
                onChange={handleChange}
                inputProps={{ maxLength: 256 }}
                helperText="A suffix like 'gov' matches every *.gov address; 'gov.in' matches every *.gov.in. A full domain like 'agency.gov' covers that org and its subdomains. A full email matches one person. Most specific rule wins."
              />
            </Box>

            <Box mb={"15px"}>
              <FormControl fullWidth>
                <InputLabel id="demo-domain-status-label">Status</InputLabel>
                <Select
                  labelId="demo-domain-status-label"
                  label="Status"
                  name="Status"
                  value={formData.Status}
                  onChange={handleChange}
                >
                  <MenuItem value="ALLOWED">ALLOWED — receives access code</MenuItem>
                  <MenuItem value="BLOCKED">BLOCKED — suspected competitor</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box mb={"15px"}>
              <TextField
                label="Note (internal)"
                fullWidth
                name="Note"
                value={formData.Note}
                onChange={handleChange}
                inputProps={{ maxLength: 256 }}
              />
            </Box>
          </Box>
          <Divider
            sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }} />
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px" }}>
            <Button variant='text'
              onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton
              variant='contained'
              loading={loading}
              disabled={!(formData.Domain !== "")}
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default DemoCertifyDomainsModal;
